export const subscriptionPlansApiPageSelector = (state, page) => {
  return state.api.subscriptionPlans.pages[page];
};
